import { FORECAST_RUNS } from '@/features/decisions/config/forecastRuns';

// The forecast behind a decision date is the run cut the day before it.
//
// Returns null rather than throwing on a period that is empty or unparseable: the decision date is
// blank until the run's periods are known, and `new Date('T12:00:00Z').toISOString()` raises
// RangeError, which took down the whole page through the error boundary.
export function forecastRunIdForPeriod(period: string): string | null {
  if (!period) return null;

  const cutoff = new Date(`${period}T12:00:00Z`);
  if (Number.isNaN(cutoff.getTime())) return null;

  cutoff.setUTCDate(cutoff.getUTCDate() - 1);
  const fct = cutoff.toISOString().slice(0, 10);

  return FORECAST_RUNS.find((run) => run.fct === fct)?.forecast_run_id ?? null;
}
